/* eslint-disable @typescript-eslint/ban-ts-comment */
import Button from "../../components/Shared/Button";
import Input from "../../components/Shared/Input";
import { useFormik } from "formik";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../utils/consts";
import { useMutation } from "@tanstack/react-query";
import * as Yup from "yup";
import { useState } from "react";
import { toast } from "react-toastify";
import { queryClient } from "../../main";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AddNewOfflineChapter } from "../../api/OfflineCourses/AddOfflineChapter";
interface Lecture {
  title: string;
}

interface Module {
  id: number;
  name: string;
  description: string;
  lectures: Lecture[];
}

const AddOfflineLectures = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [modules, setModules] = useState<Module[]>([
    { id: 1, name: "", description: "", lectures: [] },
  ]);
  const navigate = useNavigate()
  const { id: courseId } = useParams();
  const createValidationSchema = () => {
    const moduleSchemas = modules.map((module, index) => {
      const lectureSchemas = module.lectures.map((_, lectureIndex) => ({
        [`title${index}${lectureIndex}`]: Yup.string().required(
          "Lecture title is required"
        ),
      }));

      return Yup.object().shape({
        [`moduleName${index}`]: Yup.string().required(
          "Module name is required"
        ),
        [`moduleDescription${index}`]: Yup.string().required(
          "Module description is required"
        ),
        ...lectureSchemas.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
      });
    });

    return Yup.object().shape({
      modules: Yup.array().of(
        Yup.object().shape(
          moduleSchemas.reduce((acc, curr) => ({ ...acc, ...curr.fields }), {})
        )
      ),
    });
  };

  const addModule = () => {
    setModules([
      ...modules,
      { id: modules.length + 1, name: "", description: "", lectures: [] },
    ]);
  };

  const addLecture = (moduleId: number) => {
    const newModules = modules.map((module) => {
      if (module.id === moduleId) {
        const newLectures = [
          ...module.lectures,
          { title: "" },
        ];
        return { ...module, lectures: newLectures };
      }
      return module;
    });
    setModules(newModules);
  };
  const { mutate, error } = useMutation({
    mutationFn: AddNewOfflineChapter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["courses"] });
      formik.setSubmitting(false);
      setIsSubmitted(true);
      toast.success("Course Added successfully");
    },
    onError: (error) => {
      toast.error("Error adding course");
      console.error(error);
    },
  });
  const formik = useFormik({
    initialValues: {},
    validationSchema: createValidationSchema(),
    onSubmit: () => {
      const payload = modules.map((module) => ({
        name: module.name,
        description: module.description,
        courseId,
        lectures: module.lectures.map((lecture) => ({
          title: lecture.title,
        })),
      }));
      //@ts-expect-error
      mutate(payload);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="pt-5 pb-20">
      <div className="flex justify-between mb-6">
        <h1 className="text-burntBlack font-bold text-[32px] mt-5">
          Add new lectures
        </h1>
        <Button
          className="!h-11 w-40 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
          variant="primary"
          onClick={() => navigate(-1)}
          type={ButtonTypes.BUTTON}
        >
          Get Back
          {/* {isPending ? (
          <Spinner />) : ('')} */}
        </Button>
      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15 min-h-[70vh] space-y-5">
        {modules.map((module, moduleIndex) => (
          <div key={moduleIndex} className="flex gap-7">
            <div className="min-w-[671px]">
              <h1 className="font-bold text-2xl">Module {module.id}</h1>
              <div className="space-y-7 pl-4 pr-6 py-5 mt-2 rounded-lg bg-[#F5F6F8]">
                <div className="flex gap-5 w-full">
                  <Input
                    value={module.name}
                    onChange={(e) => {
                      const newName = e.target.value;
                      setModules(
                        modules.map((m) =>
                          m.id === module.id ? { ...m, name: newName } : m
                        )
                      );
                    }}
                    className="text-lg font-semibold w-full"
                    inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                    title="Module Name"
                    placeholder=""
                    name="name"
                    type="text"
                  />
                  <Input
                    value={module.description}
                    onChange={(e) => {
                      const newDescription = e.target.value;
                      setModules(
                        modules.map((m) =>
                          m.id === module.id
                            ? { ...m, description: newDescription }
                            : m
                        )
                      );
                    }}
                    className="text-lg font-semibold w-full"
                    inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                    title="Description"
                    placeholder=""
                    name="description"
                    type="text"
                  />
                </div>
                {module.lectures.map((lecture, lectureIndex) => (
                  <>
                    <div key={lectureIndex} className="flex gap-5 w-full">
                      <Input
                        value={lecture.title}
                        onChange={(e) => {
                          const newTitle = e.target.value;
                          const updatedModules = modules.map((m) => {
                            if (m.id === module.id) {
                              return {
                                ...m,
                                lectures: m.lectures.map((l, i) =>
                                  i === lectureIndex
                                    ? { ...l, title: newTitle }
                                    : l
                                ),
                              };
                            }
                            return m;
                          });
                          setModules(updatedModules);
                        }}
                        className="text-lg font-semibold w-full"
                        inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                        title={`Lecture ${lectureIndex + 1} Name`}
                        placeholder=""
                        name={`title${lectureIndex}`}
                        type="text"
                      />
                    </div>
                  </>
                ))}
                <Button
                  type={ButtonTypes.BUTTON}
                  onClick={() => addLecture(module.id)} // Ensure this function is defined and correctly adds a resource
                  disabled={formik.isSubmitting}
                  variant="primary"
                  className="!bg-[#DBF0FE] !text-[#4379EE] border-[#62BDF8] border hover:border-transparent hover:text-white hover:!bg-[#62BDF8] !h-10 w-40 px-1 text-lg font-bold"
                >
                  Add Lecture
                </Button>
                {error instanceof AxiosError && (
                  <span className="text-red-500 font-bold text-lg">
                    {typeof error?.response?.data?.message === "string"
                      ? error?.response?.data?.message
                      : "An error occurred"}
                  </span>
                )}
              </div>
            </div>
            <div className="max-w-[364px]">
              <h1 className="mb-2.5 font-bold text-2xl text-primary">
                Course Contnet
              </h1>
              <p className="text-lightGray font-medium">
                Add your modules here. Every modules overage 30-60 minutes,
                divided into short video lessons of 2-15 minutes(almost)
              </p>
            </div>
          </div>
        ))}

        <div className="pt-6 flex gap-9">
          <Button
            type={ButtonTypes.BUTTON}
            onClick={addModule}
            variant="primary"
            className="!bg-[#DBF0FE] !text-[#4379EE] border-[#62BDF8] border hover:border-transparent hover:text-white hover:!bg-[#62BDF8] !h-10 w-40 px-1 text-lg font-bold"
          >
            Add Module
          </Button>
          <Button
            type={ButtonTypes.SUBMIT}
            disabled={formik.isSubmitting || isSubmitted}
            variant="primary"
            className="!h-10 w-40 px-1 text-lg font-bold"
          >
            Submit
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddOfflineLectures;
